import colors from '@/theme/colors';
import { css } from '@emotion/css';

const styles = {
  container: css`
    & > .MuiIconButton-root {
      color: ${colors.prussian};
      padding: 8px;
    }
  `,
  backButtton: css`
    height: 40px;
    border-radius: 12px;
    background-color: ${colors.prussian700};
    display: flex;
    align-items: center;
    cursor: pointer;
    button {
      padding: 8px 4px 8px 8px;
    }
    svg {
      color: ${colors.white} !important;
      font-size: 25px;
    }
  `,
  backButtonText: css`
    color: ${colors.white} !important;
    font-size: 16px;
    line-height: 1.5;
    left: -8px;
    font-weight: bold !important;
    padding-right: 16px;
  `,
};

export default styles;
